export default __webpack_public_path__ + "static/media/img_step_lucia03-06.3f453ae3.jpg";